import axios from 'axios';
import { API_URL } from "../_config/config.const";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader, getUploadHeader } from "../_helpers/header.helper";
import { getQuery } from '../_helpers/query.helper';
import { tokenService } from './token.service';


const API_NAME = "fileUpload";

export const fileUploadService = {
    get,
    getAll,
    getAllWithBulkUpload,
    getAllFiles,
    uploadFile,
    disable,
    download
};

async function get(value: number, query?: any) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return await fetch(`${API_URL}/${API_NAME}/get/?id=${value}&${getQuery(query)}`, requestOptions).then(handleResponse);
}

async function getAll(fileTypeId: number, query?: any) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return await fetch(`${API_URL}/${API_NAME}/getAll/?fileTypeId=${fileTypeId}&${getQuery(query)}`, requestOptions).then(handleResponse);
}

async function getAllWithBulkUpload(fileTypeId: number, query?: any) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return await fetch(`${API_URL}/${API_NAME}/getAllWithBulkUpload/?fileTypeId=${fileTypeId}&${getQuery(query)}`, requestOptions).then(handleResponse);
}

function getAllFiles(ids: Array<number>) {
    let _ids = ids.join("&ids=");
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetAllFiles/?ids=${_ids}`, requestOptions).then(handleResponse);
}

function uploadFile(model?: FormData) {
    const config = {
        headers: getUploadHeader()
    }

    return axios.post(`${API_URL}/${API_NAME}/UploadFile`, model, config);
}

function disable(id: any) {
    const requestOptions = { method: 'DELETE', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/disable/?uploadFileId=${id}`, requestOptions).then(handleResponse);
}

function download(id: any) {
    //tokenService.GetReportToken().then((data) => {
    //    //return window.open(API_URL + "/quotationLog/GetFile/?token=" + data + "&fileUploadId=" + id, "_blank");
    //    return window.open(`${API_URL}/${API_NAME}/GetFile/?token=${data}&fileUploadId=${id}`, "_blank");
    //});

    tokenService.GetReportToken().then((data) => {
        const url = `${API_URL}/${API_NAME}/GetFile/?token=${data}&fileUploadId=${id}`;

        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = url;

        document.body.appendChild(iframe);

        setTimeout(() => iframe.remove(), 60000);
    });
}

